/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import NewsStory from './NewsStory';

/**
 * <NewsStory /> module exports
 */
export { NewsStory as default };



// WEBPACK FOOTER //
// ./src/js/News/components/NewsStory/index.js